module.exports = __webpack_public_path__ + "img/2.28bd9799.png";